import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import WelcomeImage from '../../assets/img/praia/inicial.jpg'; // Substitua pelo caminho correto da imagem
import Logo1 from '../../assets/img/praia/logo.jpg'
import Rodape1 from '../../assets/img/praia/rodape.jpg'; 
import config from '../../config/request.config'
import {
  Button,
  ButtonLogoff,
  Container,
  Content,
  ErrorLabel,
  Form,
  FormGroup,
  Input,
  Label,
  Logo,
  Rodape,
  StyledRadio
} from './styled'

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    clienteXpVisa: '',
  });
  const [formErrors, setFormErrors] = useState({
    name: false,
    code: false,
    clienteXpVisa: false,
  });
  const [showWelcomeScreen, setShowWelcomeScreen] = useState(true);
  const [connection, setConnection] = useState(true);

  const getQuantityRegisters = async (user: any) => {
    try {
      await axios
        .get(`${config.HOST}:${config.PORT}/v1/subscription/quantity/${user}`)
        .then(() => setConnection(true))
        .catch(() => {
          alert('Ops, servidor desativado!');
          setConnection(false);
        });
    } catch (error) {
      setConnection(false);
    }
  };

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const newFormErrors = {
      name: false,
      code: false,
      clienteXpVisa: false,
    };

    const form = event.target as HTMLFormElement;
    const nameInput = form.elements.namedItem('name') as HTMLInputElement;
    const codeInput = form.elements.namedItem('code') as HTMLInputElement;

    if (nameInput.value === '') newFormErrors.name = true;
    if (codeInput.value === '') newFormErrors.code = true;
    if (!formData.clienteXpVisa) newFormErrors.clienteXpVisa = true;

    setFormErrors(newFormErrors);

    if (Object.values(newFormErrors).every((err) => !err)) {
      const submissionData = {
        name: nameInput.value,
        code: codeInput.value,
        clienteXpVisa: formData.clienteXpVisa, // Use o estado correto
      };

      console.log('Form Data:', submissionData);
      localStorage.setItem('oxCustom', JSON.stringify(submissionData));
      navigate('/scratch');
    }

  };

  const handleRadioChange = (value: string) => {
    setFormData((prevData) => ({
      ...prevData,
      clienteXpVisa: value,
    }));
  };

  useEffect(() => {
    const user = localStorage.getItem('isAuthenticated');
    getQuantityRegisters(String(user));
  }, []);

  return (
    <Container>
      {!connection ? (
        <Content>
          <Row>
            <Col md="6">
              <h1>FALHA NA CONEXÃO COM O SERVIDOR</h1>
            </Col>
          </Row>
          <Button
            onClick={() => {
              const user = localStorage.getItem('isAuthenticated');
              getQuantityRegisters(String(user));
            }}
          >
            Tentar novamente
          </Button>
        </Content>
      ) : showWelcomeScreen ? (
        <Content
          onClick={() => setShowWelcomeScreen(false)}
          style={{
            backgroundImage: `url(${WelcomeImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '100%',
            width: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        />
      ) : (
        <Content>
          <Logo src={Logo1} alt="Logo" />
          <Form onSubmit={handleFormSubmit}>
            <FormGroup>
              <Label htmlFor="name">NOME</Label>
              <Input type="text" id="name" autoComplete="off" />
              {formErrors.name && <ErrorLabel>Campo obrigatório</ErrorLabel>}

              <Label htmlFor="code">CÓDIGO BENEFICIO</Label>
              <Input type="text" id="code" autoComplete="off" />
              {formErrors.code && <ErrorLabel>Campo obrigatório</ErrorLabel>}

              <Label>CLIENTE XP | VISA</Label>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '20px' }}>
                <div>
                  <Input
                    type="radio"
                    id="clienteXpVisaSim"
                    name="clienteXpVisa"
                    value="Sim"
                    onChange={() => handleRadioChange('Sim')}
                    style={{
                      marginLeft: '8px',
                      transform: 'scale(2.2)',
                      marginRight: '15px',
                      cursor: 'pointer',
                      appearance: 'none', // Remove o estilo padrão
                      backgroundColor: '#F0D8C0', // Cor de fundo personalizada
                      border: '2px solid #000', // Borda preta
                      borderRadius: '50%', // Formato circular
                      width: '20px',
                      height: '20px',
                      position: 'relative',
                    }}
                  />
                  <Label htmlFor="clienteXpVisaSim" style={{ marginLeft: '15px' }}>Sim</Label>
                </div>
                <div>
                  <Input
                    type="radio"
                    id="clienteXpVisaNao"
                    name="clienteXpVisa"
                    value="Não"
                    onChange={() => handleRadioChange('Não')}
                    style={{
                      marginLeft: '200px',
                      transform: 'scale(2.2)',
                      marginRight: '15px',
                      cursor: 'pointer',
                      appearance: 'none',
                      backgroundColor: '#F0D8C0',
                      border: '2px solid #000',
                      borderRadius: '50%',
                      width: '20px',
                      height: '20px',
                      position: 'relative',
                    }}
                  />
                  <Label htmlFor="clienteXpVisaNao" style={{ marginLeft: '15px' }}>Não</Label>
                </div>
              </div>


              {formErrors.clienteXpVisa && <ErrorLabel>Campo obrigatório</ErrorLabel>}
            </FormGroup>

            <Button>INICIAR</Button>
            <ButtonLogoff
              onClick={() => {
                localStorage.removeItem('isAuthenticated');
                navigate('/login');
              }}
            >
              Deslogar
            </ButtonLogoff>
              </Form>
              <Rodape src={Rodape1} alt="Rodape" />
        </Content>
      )}
    </Container>
  );
};

export default Login;
